define(['rest/utils', 'http', 'security', 'requester/urlBuilder', '../request/requestParamsFactory', 'lodash/core',
    '../request/contentTypeConfigurer'],
function(utils, http, security, urlBuilder, createRequestParams, _, contentTypeConfigurer) {
    return function(maxNoOfElementsInBatchRequest, endpoints, securityKeyName) {
        return function(fields, options, callback) {
            var queryParams = {},
                bodyParams = {},
                rawBatchItems,
                endpoint;

            queryParams.key = utils.required(security.getKey(securityKeyName));

            rawBatchItems = utils.required(options.batchItems);

            fields = contentTypeConfigurer.setField(fields);
            bodyParams.batchItems = rawBatchItems.map(function(item) {
                var requestParams = createRequestParams(fields, contentTypeConfigurer.setValue(item)),
                    pathParams = requestParams.pathParams,
                    queryParams = requestParams.queryParams,
                    postParams = requestParams.postParams,
                    request;

                request = {
                    query: urlBuilder(endpoints.single, pathParams, queryParams)
                };

                if (!_.isEmpty(postParams)) {
                    request.post = postParams;
                }

                return request;
            });

            endpoint = bodyParams.batchItems.length <= maxNoOfElementsInBatchRequest ?
                endpoints.batchSync : endpoints.batch;

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail
            });
        };
    };
});



// WEBPACK FOOTER //
// ./rest/request/batchRequestServiceFactory.js